/* eslint-disable no-multi-assign */
/* eslint-disable no-underscore-dangle */

/**
 * env 的判断和值定义，依据业务而视
 */

let _env = 'prod';
let _subEnv = 'prod';
const { host, href } = window.location;

const isBlackHost = /m.black-unique.com/.test(host);

if (isBlackHost) {
  const isBox = /8080\//.test(href);
  const isProd = /^m.black-unique.com$/.test(host);
  if (isBox) _env = _subEnv = 'box';
  if (isProd) _env = _subEnv = 'prod';

  if (!isBox && !isProd) {
    const exec = /(.*)-m.black-unique.com/.exec(host);
    _env = exec[1].replace(/(\d{1,2})/, '');
    _subEnv = exec[1];
  }
}

if (!isBlackHost) {
  ['8080/', `${host}/box[1-9]?`, `${host}/test[1-9]?`, `${host}/public`]
    .forEach((regexp, i) => {
      const result = new RegExp(regexp).exec(href);
      if (result) {
        _env = ['box', 'box', 'test', 'prod'][i];
        _subEnv = result[0].split('/')[1];
        if (i === 0) _subEnv = 'box';
        if (i === 3) _subEnv = 'prod';
      }
    });
}

export const env = _env;

export const subEnv = _subEnv;
